export default {
  labels: {
    selectOne: 'Wähle eine Option',
    selectAll: 'Wähle alle zutreffenden Optionen',
    typeResponse: 'Gib deine Antwort in das untenstehende Textfeld ein.',
    recordResponse: 'Nimm eine Aufzeichnung auf, um die Frage zu beantworten.',
    enterNumeric: 'Gib eine numerische Antwort in das Feld unten ein.',
    rateResponseScale: 'Bewerte deine Antwort auf der angegebenen Skala.',
    sliderMinimum: 'Mindestwert: {value}',
    sliderMaximum: 'Höchstwert: {value}',
    selectOneOptionRow: 'Wähle eine Option in jeder Zeile.',
    selectAllOptionsRow: 'Wähle alle zutreffenden Optionen für jede Zeile.',
    dragAndDropResponse: 'Ziehe die Optionen, um sie nach Präferenz zu ordnen.',
    rankOrderDesktopInstruction: 'Elemente per Drag-and-Drop sortieren oder die +-Schaltfläche verwenden, um ein Element hinzuzufügen. Mit den Pfeilschaltflächen neu anordnen oder mit der Löschen-Schaltfläche entfernen.',
    alert: "Warnung",
    error: 'Bitte geben Sie eine Zahl zwischen {min} und {max} ein.',
    cameras: 'Kameras',
    microphones: 'Mikrofone',
    recording: 'Aufnahme',
    noDevicesFound: 'Keine Geräte gefunden',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    stopRecording: 'Aufnahme stoppen',
    startRecording: 'Aufnahme starten',
    disableCamera: 'Kamera deaktivieren',
    enableCamera: 'Kamera aktivieren',
    disableMicrophone: 'Mikrofon deaktivieren',
    enableMicrophone: 'Mikrofon aktivieren',
    settings: 'Einstellungen',
    recordingProgress: 'Aufnahmefortschritt',
    playbackProgress: 'Wiedergabefortschritt',
    play: 'Wiedergabe',
    pause: 'Pause',
    stop: 'Stopp',
    record: 'Aufnehmen',
    recordAgain: 'Erneut aufnehmen',
    retry: 'Erneut versuchen',
    done: 'Fertig',
    minRecordTime: 'Bitte nimm eine Antwort für {min} Sekunden auf.',
    enlargeImage: 'Bild vergrößern',
    enlargedImage: 'Vergrößertes Bild',
    close: 'Schließen',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    resetZoom: 'Zoom zurücksetzen',
    zoomLevel: 'Zoom {percentage}%',
    imagePosition: '{current} von {total}',
    previousImage: 'Vorheriges Bild',
    nextImage: 'Nächstes Bild',
    imageLoading: 'Bild wird geladen',
    imageLoadFailed: 'Bild konnte nicht geladen werden',
  },
  noSelection: "Keine Auswahl",
  actions: {
    increase: 'Erhöhen',
    decrease: 'Verringern'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Umfragevorschau Beendet',
      titleCompleted: 'Umfragevorschau Abgeschlossen',
      previewModeWarning: 'Diese Seite ist nur im Vorschaumodus sichtbar und wird echten Teilnehmern nicht angezeigt.',
      reachedEndPoint: 'Diese Umfrage hat einen Endpunkt erreicht.',
      reachedEndPointCompleted: 'Diese Vorschau hat einen Endpunkt erreicht.',
      returnToModify: 'Kehren Sie zur vorherigen Frage zurück, um Ihre Antworten zu ändern und einen anderen Umfragepfad zu testen.',
      logic: 'Logik'
    }  }
}
